import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import ProjectLeftTabs from "../components/ProjectsLeftTabs";
import ProjectsSideBar from "../components/ProjectsSideBar";
import { FilterProjectsProvider } from "../context/FilterProjectsContext";
import ProjectsPanel from "../components/ProjectsPanel";

const Projects = () => {
  return (
    <>
      <Helmet>
        <title>_projects | Mert Arinci | Full-Stack Developer</title>
        <meta
          name="description"
          content="Explore Mert Arinci's portfolio of web development projects including LiveMap, ArncAI, AutoSEO, MertCloud and more. JavaScript, React, Node.js projects showcasing full-stack expertise."
        />
        <meta
          name="keywords"
          content="Mert Arinci Projects, Web Development Portfolio, JavaScript Projects, React Applications, Node.js Projects, Full-Stack Portfolio"
        />
        <link rel="canonical" href="https://arinci.nl/projects" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Projects Portfolio - Mert Arinci | Full-Stack Developer"
        />
        <meta
          property="og:description"
          content="Explore Mert Arinci's portfolio showcasing LiveMap, ArncAI, AutoSEO, MertCloud and more innovative web development projects."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://arinci.nl/projects" />
        <meta property="og:site_name" content="Mert Arinci Portfolio" />
        <meta
          property="og:image"
          content="https://arinci.nl/og-image-projects.jpg"
        />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Projects Portfolio - Mert Arinci" />
        <meta
          name="twitter:description"
          content="Explore innovative web development projects by Mert Arinci including LiveMap, ArncAI, AutoSEO and more."
        />

        <meta name="robots" content="index, follow" />

        {/* JSON-LD Structured Data for Projects */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CreativeWork",
            name: "Mert Arinci - Project Portfolio",
            description:
              "Collection of web development projects showcasing full-stack development skills",
            author: {
              "@type": "Person",
              name: "Mert Arinci",
              jobTitle: "Full-Stack Developer",
            },
            hasPart: [
              {
                "@type": "SoftwareApplication",
                name: "LiveMap",
                description:
                  "Interactive map system for Venture Marine Services using Mapbox",
                applicationCategory: "WebApplication",
                programmingLanguage: ["JavaScript", "React", "Mapbox GL JS"],
              },
              {
                "@type": "SoftwareApplication",
                name: "ArncAI",
                description:
                  "AI chatbot platform powered by Gemini API with user authentication",
                applicationCategory: "WebApplication",
                programmingLanguage: ["JavaScript", "React", "Node.js", "SQL"],
              },
              {
                "@type": "SoftwareApplication",
                name: "AutoSEO",
                description:
                  "WordPress plugin for AI-generated SEO suggestions",
                applicationCategory: "WordPressPlugin",
                programmingLanguage: ["JavaScript", "Node.js", "PHP"],
              },
            ],
          })}
        </script>
      </Helmet>
      <FilterProjectsProvider>
        <div id="projects">
          <Navbar activePage={"projects"} />
          <div className="projects-content">
            <ProjectLeftTabs />
            <ProjectsSideBar />
            <ProjectsPanel />
          </div>
          <Footer />
        </div>
      </FilterProjectsProvider>
    </>
  );
};

export default Projects;
